"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbstractConstraint = void 0;
/**
 * Base class for ruleset constraints.
 */
class AbstractConstraint {
    constructor(cfg) {
        this.config = cfg;
    }
}
exports.AbstractConstraint = AbstractConstraint;
//# sourceMappingURL=AbstractConstraint.js.map